// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2Ifvb","legacyBtn":"MutateMid_legacyBtn__2pqDW"};